import React from 'react';
import { ScreenContainer } from '@pinwheel/origami';
import Loading from '../../LinkApiRouter/components/Loading';
var AdpLoading = function () { return (React.createElement(ScreenContainer, null,
    React.createElement("div", { style: { flex: 1, justifyContent: 'center' } },
        React.createElement(Loading, null)))); };
export default AdpLoading;
